<template>
  <section
    id="main-banner-page"
    class="position-relative page-header section-nav-smooth parallax blog-detail-header"
    style="background-image: url('fe/asset/img/big-bg-white.png')"
  >
    <!-- <div class="overlay overlay-dark opacity-8 z-index-1"></div> -->
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="page-titles whitecolor text-center padding_top">
            <!-- <h2 class="font-bold text-color-main">Mobil Listrik</h2> -->
          </div>
        </div>
      </div>
      <div class="title-wrap bg-custom">
        <div class="row">
          <div class="col-lg-12 col-md-12 whitecolor">
            <h3 class="float-left">Kontak</h3>
            <ul class="breadcrumb top10 bottom10 float-right">
              <li class="breadcrumb-item"><a href="/">Beranda</a></li>
              <li class="breadcrumb-item">Kontak</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    id="stayconnect1"
    class="bglight position-relative padding_top padding_bottom_half noshadow"
    style="
      background-image: url('fe/asset/img/big-bg-white.png');
      background-size: cover;
      border-radius: 10px !important;
    "
  >
    <div class="container whitebox">
      <div class="widget py-5">
        <div class="row">
          <div class="col-md-6 col-sm-6 order-sm-2">
            <h2 class="heading bottom30 darkcolor font-light2 pt-1">
              <span class="font-normal">FAQ</span>
              <span class="divider-left"></span>
            </h2>
            <div class="col-md-12">
              <p class="heading_space">
                <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A
                dolores explicabo laudantium, omnis provident quam reiciendis
                voluptatum? -->
              </p>
            </div>

            <div id="accordion">
              <template v-for="(item, key) in rulesList" :key="key">
                <div class="card">
                  <div class="card-header">
                    <a
                      class="card-link darkcolor"
                      data-toggle="collapse"
                      :href="`#collapse${key}`"
                      >{{ item.answer }}</a
                    >
                  </div>
                  <div
                    :id="`collapse${key}`"
                    class="collapse"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      {{ item.answer }}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <h2 class="heading bottom30 darkcolor font-light2 pt-1">
              <span class="font-normal">Contact</span> Us
              <span class="divider-left"></span>
            </h2>
            <div class="col-md-12">
              <p class="heading_space">
                <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. A
                dolores explicabo laudantium, omnis provident quam reiciendis
                voluptatum? -->
              </p>
            </div>
            <div class="heading-title wow fadeInUp" data-wow-delay="300ms">
              <!-- <form
                class="getin_form wow fadeInUp"
                data-wow-delay="400ms"
                id="contact-form-data"
              > -->
              <b-overlay :show="isLoading" rounded="sm">
                <Form
                  class="getin_form border-form"
                  id="login"
                  :validation-schema="schema"
                  @submit="submitFaq"
                >
                  <div class="row px-2">
                    <div class="col-md-12 col-sm-12" id="result"></div>
                    <div class="col-md-12 col-sm-12">
                      <div class="form-group">
                        <label for="name1" class="d-none"></label>
                        <Field
                          class="form-control"
                          id="name"
                          type="text"
                          placeholder="Name:"
                          required
                          name="name"
                          v-model="loginData.name"
                        />
                        <ErrorMessage class="text-danger" name="name" />
                      </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                      <div class="form-group">
                        <label for="email1" class="d-none"></label>
                        <Field
                          class="form-control"
                          type="email"
                          id="email"
                          placeholder="Email:"
                          name="email"
                          v-model="loginData.email"
                        />
                        <ErrorMessage class="text-danger" name="email" />
                      </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                      <div class="form-group">
                        <label for="message1" class="d-none"></label>
                        <Field
                          as="textarea"
                          class="form-control"
                          id="message"
                          placeholder="Message:"
                          requiredtextarea
                          name="message"
                          v-model="loginData.message"
                        />
                        <ErrorMessage class="text-danger" name="message" />
                      </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                      <div class="form-group bottom25 text-center">
                        <div class="d-flex w-100 justify-content-center">
                          <RecaptchaV2
                            @widget-id="handleWidgetId"
                            @error-callback="handleErrorCalback"
                            @expired-callback="handleExpiredCallback"
                            @load-callback="handleLoadCallback"
                            language="id"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                      <button
                        type="submit"
                        id="submit_btn1"
                        class="contact_btn button gradient-btn w-100"
                      >
                        Kirim
                      </button>
                    </div>
                  </div>
                </Form>
              </b-overlay>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import Datatable from "@/components/kt-datatable/KTDataTable.vue";
import type { Sort } from "@/components/kt-datatable//table-partials/models";
import { useCmsStores } from "@/store/cms";
import { getFilePath } from "@/core/helpers/assets";
import { Form, Field, ErrorMessage } from "vee-validate";
import { RecaptchaV2 } from "vue3-recaptcha-v2";
import Swal from "sweetalert2/dist/sweetalert2.js";


import * as yup from "yup";

export default defineComponent({
  components: {
    Datatable,
    Form,
    Field,
    ErrorMessage,
    RecaptchaV2,
  },
  setup() {
    const tableHeader = ref([
      {
        columnName: "No",
        columnLabel: "id",
        sortEnabled: true,
        columnWidth: 40,
      },
      {
        columnName: "Tahun",
        columnLabel: "tahun_terbit",
        sortEnabled: true,
        columnWidth: 100,
      },
      {
        columnName: "Kategori",
        columnLabel: "category_id",
        sortEnabled: false,
        columnWidth: 175,
      },
      {
        columnName: "Judul",
        columnLabel: "title",
        sortEnabled: true,
        columnWidth: 300,
      },
      {
        columnName: "Aksi",
        columnLabel: "actions",
        sortEnabled: false,
        columnWidth: 60,
      },
    ]);

    const queryParams = reactive({
      limit: 1000,
      page: 1,
      sort: "asc",
      orderBy: "id",
      with_users: true,
      category_id: "",
      keyword: "",
      tahun_terbit: "",
    });

    const cmsStore = useCmsStores();
    const rulesList = ref([]);
    const rulesMeta = reactive({
      limit: 10,
      offset: 0,
      page: 1,
      total_data: 0,
    });
    const rulesCategoryList = ref([]);
    const isLoading = ref(false);
    const listTahun = ref([]);

    // get tahun 5 tahun terakhir dan 5 tahun ke depan
    const getTahun = () => {
      const date = new Date();
      const tahun = date.getFullYear();
      const tahunAwal = tahun - 7;
      const tahunAkhir = tahun;

      for (let i = tahunAwal; i <= tahunAkhir; i++) {
        listTahun.value.push(i);
      }
    };

    const getRules = async () => {
      await cmsStore.getFaqList(queryParams).then((res) => {
        // console.log(res.data.data.data);
        rulesList.value = res.data.data.data;
        rulesMeta.limit = res.data.data.limit;
        rulesMeta.offset = res.data.data.offset;
        rulesMeta.page = res.data.data.page;
        rulesMeta.total_data = res.data.data.total_data;
      });
    };

    const getRulesCategory = async () => {
      // await cmsStore.getRulesCategory().then((res) => {
      //   rulesCategoryList.value = res.data.data;
      // });
    };

    const search = ref<string>("");
    const searchItems = async () => {
      if (search.value !== "") {
        queryParams.keyword = search.value;
      } else {
        queryParams.keyword = "";
      }

      await getRules();
    };

    const sort = async (sort: Sort) => {
      queryParams.sort = sort.order;
      queryParams.orderBy = sort.label ?? "sort";

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    const itemsPerPageChange = async (page: number) => {
      queryParams.limit = page;

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    const pageChange = async (page: number) => {
      queryParams.page = page;

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    const handleCategoryChange = async (event: any) => {
      queryParams.category_id = event.target.value;

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    const handleTahunChange = async (event: any) => {
      queryParams.tahun_terbit = event.target.value;

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    const loginData: any = reactive({
      name: "",
      email: "",
      message: "",
      recaptcha_token: "",
    });

    const schema = yup.object({
      name: yup.string().required((data) => `Nama tidak boleh kosong !`),
      email: yup
        .string()
        .required((data) => `Email tidak boleh kosong !`)
        .email((data) => `Email tidak valid !`),
      message: yup
        .string()
        .required("Pesan tidak boleh kosong !")
        .min(10, "Pesan minimal 10 karakter"),
    });

    const handleWidgetId = (widgetId: number) => {
      // console.log("Widget ID: ", widgetId);
    };
    const handleErrorCalback = () => {
      // console.log("Error callback");
      loginData.recaptcha_token = "";
    };
    const handleExpiredCallback = () => {
      // console.log("Expired callback");
      loginData.recaptcha_token = "";
    };
    const handleLoadCallback = (response: unknown) => {
      // console.log("Load callback", response);
      loginData.recaptcha_token = response;
    };

    const submitFaq = async () => {
      // console.log("submitFaq");
      // console.log(loginData);
      if (loginData.recaptcha_token == "") {
        return;
      }

      isLoading.value = true;
      await cmsStore.postFaq(loginData).then((res) => {
        isLoading.value = false;
        // console.log(res);
        Swal.fire({
          title: "Berhasil",
          text: "Pesan berhasil dikirim, balasan akan dikirimkan melalui email",
          icon: "success",
          confirmButtonText: "OK",
        }).then((result) => {
          loginData.name = "";
          loginData.email = "";
          loginData.message = "";
          // loginData.recaptcha_token = "";
          // if (result.isConfirmed) {
          //   window.location.href = "/login";
          // }
        })
      }).catch((err) => {
        isLoading.value = false;
        Swal.fire({
          title: "Gagal",
          text: "Pesan gagal dikirim, silahkan coba lagi",
          icon: "error",
          confirmButtonText: "OK",
        }).then((result) => {
          // if (result.isConfirmed) {
          //   window.location.href = "/login";
          // }
        })
      });
    };

    onMounted(async () => {
      isLoading.value = true;
      getTahun();
      await getRulesCategory();
      await getRules();
      isLoading.value = false;
    });

    return {
      tableHeader,
      queryParams,
      rulesList,
      rulesMeta,
      isLoading,
      search,
      searchItems,
      sort,
      itemsPerPageChange,
      pageChange,
      getFilePath,
      rulesCategoryList,
      listTahun,
      handleCategoryChange,
      handleTahunChange,
      loginData,
      schema,
      submitFaq,
      handleWidgetId,
      handleErrorCalback,
      handleExpiredCallback,
      handleLoadCallback,
    };
  },
});
</script>
